import React from 'react';
import './statementTemplate-view.css';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';

class HomeView extends React.Component {

  state = {
    statementTemplate: {},
    compiled:''
  }

  handleChange = (value, prop) => {
    var t = this.state.statementTemplate;
/*
    hb.registerHelper('dateFormat', function (date, options) {
      const formatToUse = (arguments[1] && arguments[1].hash && arguments[1].hash.format) || "YYYY-MM-DD"
      return moment(date).format(formatToUse);
  });

    const template = hb.compile(value, { strict: false });
    let c = t;

    if(prop =='template') {
      try{
        c =template({});
      }
      catch {
       
      }
    }
    */
     t[prop] = value;
    this.setState({
      statementTemplate: t,
     // compiled: c
    });
  }

  componentDidMount() {
    this.props.getStatementTemplate(this.props.match.params.id);
  }

  componentWillUpdate(props, state) {
    if (props.statementTemplate && state.statementTemplate) {
      if (state.statementTemplate._id != props.statementTemplate._id) {
        this.setState({
          statementTemplate: props.statementTemplate,
          //compiled: props.statementTemplate.template
        });
      }
    }

    return true;
  }

  save = () => {
      this.props.saveStatementTemplate(this.state.statementTemplate);
  }

  scrollToTop = () => window.scrollTo(0, 0);

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

   console.log(this.state.statementTemplate);

    return (
      <div className="content-wrapper pl-4 pr-4">
      <SpinnerView showSpinner={this.props.loading} />

        {this.state.statementTemplate && <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: 'var(--text-secondary)', marginBottom: 6 }}>Template Name</label>
          <input type="text" onChange={(e) => this.handleChange(e.target.value, 'statementTemplateName')} value={this.state.statementTemplate.statementTemplateName} style={{ width: '100%', padding: '11px 14px', border: '1px solid rgba(15,31,46,0.12)', borderRadius: 10, fontSize: 14, outline: 'none', background: 'rgba(255,255,255,0.7)' }} />
        </div>}

        {this.state.statementTemplate && <div class="form-group green-border-focus">
          <label for="exampleFormControlTextarea5">statementTemplateEmailBody</label>
          <textarea class="form-control" id="exampleFormControlTextarea5" onChange={(e) => this.handleChange(e.target.value, 'statementTemplateEmailBody')} value={this.state.statementTemplate.statementTemplateEmailBody}  rows="3"></textarea>
        </div>}

        {this.state.statementTemplate && this.state.statementTemplate.statementTemplateEmailBody && <div dangerouslySetInnerHTML={{__html: this.state.statementTemplate.statementTemplateEmailBody.replace(/(<script)/gi, 'illegalscript')}} ></div>}

        {this.state.statementTemplate && <div class="form-group green-border-focus">
          <label for="exampleFormControlTextarea5">Template</label>
          <textarea class="form-control" id="exampleFormControlTextarea5" onChange={(e) => this.handleChange(e.target.value, 'template')} value={this.state.statementTemplate.template}  rows="3"></textarea>
        </div>}

        {this.state.statementTemplate && this.state.statementTemplate.template && <div dangerouslySetInnerHTML={{__html: this.state.statementTemplate.template.replace(/(<script)/gi, 'illegalscript')}} ></div>}

        <button type="button" onClick={this.save} style={{ background: 'linear-gradient(135deg, var(--primary), var(--primary-dark))', border: 'none', color: '#fff', borderRadius: 10, padding: '10px 20px', fontWeight: 700, fontFamily: 'var(--font-display)', fontSize: 14, cursor: 'pointer' }}>Save</button>

      </div>
    );
  }
}

export default HomeView;
